import { HttpErrorResponse } from '@angular/common/http';

/**
 * Extract a human-readable message from a failed HTTP call.
 * The Idio backend returns errors as `{ "detail": "..." }`.
 */
export function httpErrorMessage(err: unknown, fallback: string): string {
  if (err instanceof HttpErrorResponse) {
    const detail = (err.error as { detail?: unknown } | null)?.detail;
    if (typeof detail === 'string' && detail) return detail;
    if (err.message) return err.message;
  }
  return fallback;
}
